<style lang="less">
  @import 'Login.less';
</style>

<template>
  <div class="login" :style="{backgroundImage: 'url('+require('../../assets/images/login-bg.png')+')'}">
  <div class="topText">推荐使用谷歌、火狐浏览器。（IE浏览器可能存在不兼容性；在使用QQ、360浏览器时请切换至极速模式。）</div>
    <div class="login-con" :style="{backgroundImage: 'url('+require('../../assets/images/login-bg-m.png')+')'}">
      <div class="login-box">
        <div class="login-title">
          <p>上海市绿色建筑协会专家系统</p>
        </div>
        <Tabs v-model="type">
          <TabPane label="账号登录" name="0">
            <ul class="login-main">
              <li>
                <input type="text" placeholder="请输入手机号/邮箱" v-model="username"/>
              </li>
              <li>
                <input type="password" placeholder="请输入密码" maxlength="16" v-model="password"/>
              </li>
              <li>
                <span @click="toRegister">注册账号</span>
                <span @click="toForgetPassword">忘记密码</span>
                <span @click="jumpAdmin" style="margin-left: 55px;">跳转后台管理</span>
              </li>
            </ul>
          </TabPane>
          <TabPane label="验证码登录" name="1">
            <ul class="login-main">
              <li>
                <input type="text" placeholder="请输入手机号" v-model="phone"/>
              </li>
              <li class="code">
                <input placeholder="请输入验证码" maxlength="6" v-model="verifycode"/>
                <span @click="sendVerifyCode" :style="isCountDownIng && 'color: #ccc;border-color:#ccc'">{{this.isCountDownIng ? this.countDown + 's' : '获取验证码'}}</span>
              </li>
              <li>
                <span @click="toRegister">注册账号</span>
              </li>
            </ul>
          </TabPane>
        </Tabs>
        <Button @click="login" :loading="loading">登录</Button>
      </div>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import PageName from '../../constant/PageName';
  import * as Cache from '../../cache/Cache';
  import {isMobile} from '../../libs/CheckUtil';
  import * as ExpertLibraryAPI from '../../api/ExpertLibraryAPI';
  import {toast, showLoading, dismissLoading} from '../../libs/LoadingUtil';
import { setTimeout, clearTimeout } from 'timers';

  export default {
    data () {
      return {
        countDown: 60,// 倒计时秒数
        isCountDownIng: false,// 是否正在倒计时
        loading: false,//按钮加载
        username:'',
        password:'',
        type:"0",
        phone:'',
        verifycode:'',//验证码
      };
    },
    mounted(){
      this.$store.commit("clearMenuList");
      
    },
    methods: {
      jumpAdmin () {
        window.location.href = 'http://117.74.136.106:11137/experts/ExpertLibraryAdmin/#/login'
      },
      toRegister(){
        this.router.push({
          name: PageName.PAGE_REGISTER
        });
      },
      toForgetPassword(){
        this.router.push({
          name: PageName.PAGE_FORGET_PASSWORD
        });
      },
      /** 验证码倒计时 */
      startCountDown(){
        this.timer = setInterval(() => {
          this.countDown = this.countDown - 1;
          this.isCountDownIng = true;
          if (this.countDown === 0) {
            this.timer && clearInterval(this.timer);
            this.countDown = 60;
            this.isCountDownIng = false;
          }
        }, 1000);
      },
      /** 重置倒计时 */
      resetCountDown(){
        this.timer && clearInterval(this.timer);
        this.countDown = 60;
        this.isCountDownIng = false;
      },
      //发送验证码
      sendVerifyCode(){
        if (!this.isCountDownIng) {
          if (!this.phone) {
            toast('请输入手机号码');
            return;
          }
          if (!isMobile(this.phone)) {
            toast('手机号码格式不正确');
            return;
          }
          this.asyncSendLoginVerifyCode();
        }
      },
      asyncSendLoginVerifyCode(){
        let params = {
          phone_no:this.phone,
        }
        this.startCountDown();
        ExpertLibraryAPI.sendLoginVerifyCode(params, (resp)=>{
          toast('验证码发送成功');
        }, (failResp)=>{
          this.resetCountDown();
        });
      },
      login(){
        if(this.type == "0") {
          //密码登录
          if (!this.username) {
            toast('请输入手机号/邮箱');
            return;
          }
          if (!this.password) {
            toast('请输入密码');
            return;
          }
        } else {
          //验证码登录
          if (!this.phone) {
            toast('请输入手机号');
            return;
          }
          if (!this.verifycode) {
            toast('请输入验证码');
            return;
          }
        }

        this.asyncDoLogin();
      },
      asyncDoLogin(){
        let params;
        if(this.type == "0") {
          params = {
            username:this.username,
            password:this.password,
            type:this.type
          }
        } else {
          params = {
            username:this.phone,
            verifycode:this.verifycode,
            type:this.type
          }
        }

        this.loading = true;
        ExpertLibraryAPI.doLogin(params, (resp)=>{
          this.loading = false;
          let userInfo = {
            userid:resp.userid,
            username:resp.username,
          }
          Cache.setUserInfo(userInfo);
          this.$store.commit('toggleFirstLogin',true)
          this.router.push({
            name: PageName.PAGE_HOME_INDEX
          });
        }, (failResp)=>{
          this.loading = false;
        });
      }
    }
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue